import {themeEl} from '@common/core/root-el';

export function setThemeValue(key: string, value: string) {
  const normalizedValue = value.replace(
    /^\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*$/,
    '$1 $2 $3',
  );
  themeEl?.style.setProperty(key, normalizedValue);
}

export function removeThemeValue(key: string) {
  themeEl?.style.removeProperty(key);
}
